/* Lea Versailles - destranca o scroll depois de fechar o UpCart.

   CAUSA REAL (medida no site):
   Ao adicionar ao carrinho, o tema Broadcast abre o SEU proprio
   cart-drawer (#cart-drawer ganha .is-open) e dispara
   'theme:scroll:lock'. A biblioteca scroll-lock tranca a pagina:
   style inline no <body>, <html data-scroll-locked> e handlers de
   touchmove com preventDefault -- por isso so congela no telemovel.
   O UpCart esconde esse drawer (display:none), mas ele fica
   .is-open para sempre, o 'theme:scroll:unlock' nunca e disparado
   e o bloqueio so sai com refresh.

   SOLUCAO: quando o UpCart fecha, fechar o cart-drawer fantasma do
   tema e disparar o 'theme:scroll:unlock' do proprio tema
   (clearQueueScrollLocks + enablePageScroll + tira os handlers de
   toque). So mexe no CART-drawer -- menu hamburguer e outros
   paineis do tema ficam intocados. */
(function () {
  'use strict';

  var body = document.body;
  var html = document.documentElement;
  if (!body || !html) return;

  var UPCART = 'upcartPopupShow';

  function upcartAberto() {
    return body.classList.contains(UPCART);
  }

  function eCartDrawer(el) {
    return el.tagName === 'CART-DRAWER' || el.id === 'cart-drawer' ||
           el.classList.contains('drawer--cart');
  }

  // com o UpCart instalado, o cart-drawer do tema nunca e mostrado
  function cartDrawerFantasma() {
    var cd = document.querySelector('cart-drawer.is-open, #cart-drawer.is-open, .drawer--cart.is-open');
    if (!cd) return null;
    var s = window.getComputedStyle(cd);
    if (s.display === 'none' || s.visibility === 'hidden' || document.getElementById('upCart')) return cd;
    return null;
  }

  // qualquer outro painel do tema aberto (menu, pesquisa, modais...)
  function outroPainelAberto() {
    var abertos = document.querySelectorAll('.drawer.is-open, dialog[open][data-scroll-lock-required]');
    for (var i = 0; i < abertos.length; i++) {
      if (!eCartDrawer(abertos[i])) return true;
    }
    return false;
  }

  function fecharFantasma() {
    var cd = cartDrawerFantasma();
    if (!cd) return false;
    try {
      if (typeof cd.closeCartDrawer === 'function') cd.closeCartDrawer();
    } catch (e) {}
    cd.classList.remove('is-open');
    return true;
  }

  function limparInline() {
    var st = body.getAttribute('style') || '';
    if (st.indexOf('overflow') !== -1 || st.indexOf('padding-right') !== -1) {
      body.style.removeProperty('overflow');
      body.style.removeProperty('padding-right');
    }
    if (!body.getAttribute('style')) body.removeAttribute('style');
  }

  function destrancar() {
    if (upcartAberto()) return;
    fecharFantasma();
    if (outroPainelAberto()) return;
    if (!html.hasAttribute('data-scroll-locked')) { limparInline(); return; }

    document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }));
    setTimeout(function () {
      if (upcartAberto() || outroPainelAberto()) return;
      if (html.hasAttribute('data-scroll-locked')) html.removeAttribute('data-scroll-locked');
      limparInline();
    }, 150);
  }

  function destrancarComAtraso() {
    destrancar();
    [80, 300, 700, 1400].forEach(function (ms) { setTimeout(destrancar, ms); });
  }

  var estava = upcartAberto();

  new MutationObserver(function () {
    var agora = upcartAberto();
    if (estava && !agora) { estava = false; destrancarComAtraso(); return; }
    estava = agora;
  }).observe(body, { attributes: true, attributeFilter: ['class'] });

  // rede de seguranca: so atua se o UpCart estiver fechado, o unico
  // painel 'aberto' for o cart-drawer fantasma e isso durar 2 ciclos
  var seguidos = 0;
  setInterval(function () {
    if (!upcartAberto() && cartDrawerFantasma() && !outroPainelAberto()) {
      seguidos++;
      if (seguidos >= 2) { seguidos = 0; destrancar(); }
    } else {
      seguidos = 0;
    }
  }, 800);

  window.addEventListener('pageshow', destrancarComAtraso);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) destrancarComAtraso();
  });
})();
